import { Box, Flex, Text } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { useTranslationAuth } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { REPLAY_BLOCK_CLASS, REPLAY_MASK_CLASS } from '@dealstack/frontend/shared/sentryPrivacy';

interface Props {
	qrCode: string;
	secret: string;
}

export const QrCodeEnrollment = ({ qrCode, secret }: Props) => {
	const tAuth = useTranslationAuth();

	return (
		<Flex direction="column" w="100%" justify="center" align="center">
			<Box
				py="1rem"
				w="100%"
				ta="center"
				style={{
					background: '#F9FAFB',
				}}
			>
				{/* The QR encodes the TOTP secret, so it is blocked from session replay. */}
				<img
					src={qrCode}
					className={`w-40 h-40 object-center ${REPLAY_BLOCK_CLASS}`}
					alt="qr code"
					data-sentry-block
				/>
			</Box>

			<Text size="B3Bold" c="dark.8" mt="1rem" ta="center">
				{tAuth('2FA.scan.title')}
			</Text>
			<Text size="B5Medium" c="dark.0" mt="1rem" ta="center">
				{`${tAuth('2FA.scan.description')}`}
			</Text>
			{/* The TOTP shared secret in plain text - masked from session replay. */}
			<Text
				mt="0.5rem"
				size="B5Bold"
				data-testid={TEST_ELEMENT_IDS.ACCOUNT_SETTING_2FA_SECRET_CODE}
				ta="center"
				className={REPLAY_MASK_CLASS}
				data-sentry-mask
			>
				{secret}
			</Text>
		</Flex>
	);
};
